import { render } from "./head.vue?vue&type=template&id=2a5f9ba6"
import script from "./head.vue?vue&type=script&lang=js"
export * from "./head.vue?vue&type=script&lang=js"

import "./head.vue?vue&type=style&index=0&id=2a5f9ba6&lang=css"
script.render = render

export default script